<template>
  <div></div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  mounted() {
    this.setMenu([])
    this.setUser(null)
    localStorage.clear()
    sessionStorage.clear()
    this.$router.push('/login')
  },
  methods: {
    ...mapActions(['setMenu', 'setUser']),
  },
}
</script>
